// extracted by mini-css-extract-plugin
module.exports = {"searchHighlight":"SearchHighlight_searchHighlight__2YW37"};